const frontpage = {
	envVarInterpolation: "Her er en miljøvariabel til deg. Verdien av {{varName}} er: {{value}}",
	envVarWithTags:
		"Og her er en oversettelse med tagger! Den viser <0>{{prop}}</0> fra <1>{{obj}}</1>-objektet: {{value}}"
} as const;

export default frontpage;
